import NewProcessoItem from './NewProcessoItem'

const { showToastify, errorDefault, FormatREALBackEnd } = GLOBAL

export default {
	components: { NewProcessoItem },
	props: ['fundacoes', 'estrategias', 'fundos', 'semestres'],
	emits: ['processo-enviado'],

	data() {},
	methods: {
		closeModalNovoProcesso() {
			modal_padrao_vue.closeModal('modal_novo_processo')
		},
		async sendNewProcesso(obj) {
			/* NProgress.start() */
			/* 			const valorInput = document.querySelector('#valor_processo')
			console.log(obj) */
			const { valor } = obj

			let valorFinal = 0
			if (valor.includes(',')) {
				const valorTransformado =
					parseFloat(valor.replaceAll('.', '').replace(',', '.')) * 10
				/* console.log(valorTransformado) */
				valorFinal = valorTransformado.toFixed(2)
			} else if (valor.length == 3) {
				valorFinal = (parseFloat(valor) / 100).toFixed(2)
			} else {
				valorFinal = valor
			}
			/* 			console.log(valor)
			console.log(valorFinal) */
			try {
				const response = await axios.post(
					`${window.location.origin}/clientes/pr	ocessos_fundacoes/`,
					{
						...obj,
						/* fundacao: this.clienteAtivo.id, */
						valor: valorFinal,
					}
				)

				if (this.clienteAtivo?.id) {
					await this.getDadosModal(this.clienteAtivo.id, true)
					await this.getProcessosFundacao(this.clienteAtivo.id)
				}
				showToastify('✅ Processo Criado com sucesso.')

				this.$emit('processo-enviado', response)
				return response
			} catch (e) {
				errorDefault(e)
			} finally {
				/* NProgress.done() */
			}
		},
	},
	mounted() {},

	template: `
		<section 
			class="modal--content rounded-md flex-1 w-auto !overflow-[initial]"
			data-id="modal_novo_processo"
			>
				<new-processo-item
					class="!border-none"
					:is-fundacao-activate="true"
					:fundacoes="fundacoes"
					:estrategias="estrategias"
					:fundos="fundos"
					:semestres="semestres"
					@cancelar="closeModalNovoProcesso"
					@enviar="(obj)=>sendNewProcesso(obj)"></new-processo-item>
		</section>
	
	`,

}
